// 导入Vue2核心（确保项目已全局引入Vue，或此处手动导入）
import Vue from 'vue'
// 导入通知组件（Vue2版本的Notification）
import Notification from './Notification.vue'

// 1. 创建挂载容器（保留原有样式和DOM结构）
const notificationContainer = document.createElement('div')
notificationContainer.className = 'notification-container'
// 固定在页面右上角（Element Plus默认位置）
Object.assign(notificationContainer.style, {
  position: 'fixed',
  top: '20px',
  right: '20px',
  'z-index': '9999',
  display: 'flex',
  'flex-direction': 'column',
  'align-items': 'flex-end'
})
document.body.appendChild(notificationContainer)

// 2. 通知实例ID计数器（用于唯一标识每个通知）
let notificationId = 0

/**
 * 对外暴露的通知调用函数（Vue2版本）
 * @param {Object} options 通知配置项
 * @returns {Object} 包含close方法的实例对象
 */
export const myNotification = (options) => {
  // 生成唯一ID
  const id = `notification_${notificationId++}`

  // 3. 合并默认配置与用户传入配置
  const defaultOptions = {
    title: '',
    message: '',
    type: 'info',
    duration: 3000
  }
  const finalOptions = { ...defaultOptions, ...options }

  // 4. 定义组件关闭回调（移除DOM + 清理实例）
  const handleClose = () => {
    // 销毁Vue组件实例（Vue2的$destroy方法）
    if (notificationInstance) {
      notificationInstance.$destroy()
    }
    // 移除对应的DOM元素（如果存在）
    const domNode = document.getElementById(id)
    if (domNode) {
      notificationContainer.removeChild(domNode)
    }
  }

  // 5. Vue2创建组件实例（替代Vue3的createVNode）
  // 第一步：创建组件构造器
  const NotificationConstructor = Vue.extend(Notification)
  // 第二步：创建组件实例，传递props数据
  const notificationInstance = new NotificationConstructor({
    propsData: finalOptions // Vue2通过propsData传递组件props
  })

  // 6. 监听组件的close事件（对应组件内的this.$emit('close')）
  notificationInstance.$on('close', handleClose)

  // 7. 为组件创建独立DOM容器并挂载
  const domNode = document.createElement('div')
  domNode.id = id
  notificationContainer.appendChild(domNode)

  // 8. 挂载组件到DOM容器（Vue2的$mount方法）
  // $mount()无参数时先挂载到内存，再手动插入DOM（避免直接挂载到body）
  notificationInstance.$mount(domNode)

  // 9. 返回实例对象（支持用户手动调用close方法关闭通知）
  return {
    close: () => {
      // 触发组件内部的关闭逻辑（先执行过渡动画，再移除DOM）
      if (notificationInstance && typeof notificationInstance.handleClose === 'function') {
        notificationInstance.handleClose()
      }
    }
  }
}

// 额外：为了和Element Plus用法一致，添加快捷方法（可选）
myNotification.success = (options) => {
  return myNotification({ ...options, type: 'success' })
}
myNotification.info = (options) => {
  return myNotification({ ...options, type: 'info' })
}
myNotification.warning = (options) => {
  return myNotification({ ...options, type: 'warning' })
}
myNotification.error = (options) => {
  return myNotification({ ...options, type: 'error' })
}